// Pure calculation helpers -- no fetching here. P&L reads from the same
// transaction data already loaded by src/transactions/transactions.js (the
// single existing data layer), so it recalculates automatically on every
// re-render after any save or site switch, with no separate P&L data source
// and no extra Supabase query.

export function computeTotals(transactions) {
  let income = 0;
  let expense = 0;
  for (const t of transactions) {
    const amt = Number(t.amount) || 0;
    if (t.type === 'income') income += amt;
    else if (t.type === 'expense') expense += amt;
  }
  const profit = income - expense;
  const profitPct = income > 0 ? (profit / income) * 100 : 0;
  return { income, expense, profit, profitPct };
}

// Period filters use entry_date (a plain 'YYYY-MM-DD' string from Postgres date),
// not created_at, and compare as strings -- no Date() construction, no timezone risk.
export function filterByDate(transactions, dateStr) {
  return transactions.filter((t) => t.entry_date === dateStr);
}

export function filterByMonth(transactions, monthStr /* 'YYYY-MM' */) {
  return transactions.filter((t) => (t.entry_date || '').slice(0, 7) === monthStr);
}

export function expenseCategoryBreakdown(transactions) {
  const totals = {};
  for (const t of transactions) {
    if (t.type !== 'expense') continue;
    const cat = t.category || 'Other';
    totals[cat] = (totals[cat] || 0) + (Number(t.amount) || 0);
  }
  return Object.entries(totals)
    .map(([category, amount]) => ({ category, amount }))
    .sort((a, b) => b.amount - a.amount);
}
